import {
  Dialog,
  DialogBody,
  DialogButton,
  DialogCloseX,
  DialogContent,
  DialogHeading,
} from "@tandemdiabetes/sugarmate-react-components"
import type { MouseEventHandler } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  open: boolean;
  setOpen: (o: boolean) => void;
  navigateToDataSource: MouseEventHandler<HTMLButtonElement>;
}

const polyglotPrefix =
  "pages.data_sharing.invite_a_follower.no_data_source_dialog."

/*
 * renders a dialog asking the user to add a data source
 */
export function NoDataSourceDialog(props: Props) {
  const {
    setOpen, open: isOpen, navigateToDataSource,
  } = props

  const polyglot = usePolyglot()

  return (
    <Dialog
      open={isOpen}
      onOpenChange={setOpen}
    >
      <DialogContent>
        <DialogHeading>
          {polyglot.t(`${polyglotPrefix}header`)}
          <DialogCloseX />
        </DialogHeading>
        <DialogBody>
          {polyglot.t(`${polyglotPrefix}description`)}
        </DialogBody>
        <DialogButton
          stylePreset="primary"
          onClick={navigateToDataSource}
        >
          {polyglot.t(`${polyglotPrefix}confirm_cta`)}
        </DialogButton>
      </DialogContent>
    </Dialog>
  )
}
